import Image from 'next/image';
import styled from '@emotion/styled';
import { css } from '@emotion/react';

const Wrapper = styled.div<{ $background?: 'gradient' | string }>`
  position: relative;
  padding: 1rem 1rem 1.75rem;
  border-radius: 0.5rem 0.5rem 0 0;
  box-shadow: 0 -0.125rem 0.25rem rgb(0 0 0 / 14%);
  color: ${({ theme }) => theme.color.white};
  background: ${({ theme, $background }) =>
    $background && $background !== 'gradient'
      ? $background
      : `linear-gradient(
          103.44deg,
          ${theme.color.primaryHighlight} 3.17%,
          ${theme.color.brand} 100%
        )`};
  background-repeat: no-repeat;
  font-family: ${({ theme }) => theme.fontFamily.alternate};
  line-height: 1.5;
  text-align: center;
  overflow: hidden;

  ${({ theme, $background }) =>
    $background !== 'gradient' &&
    css`
      svg {
        filter: invert();
      }

      path[fill^='url'] {
        fill: ${theme.color.white};
        stroke: ${theme.color.black};
        stroke-width: 1px;
      }
    `}
`;

const Swirl = styled(Image)`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 0;
`;

const Text = styled.p<{ $hasSubtitle: boolean }>`
  position: relative;
  z-index: 1;
  margin: 0 auto 1.5rem;
  margin: ${({ $hasSubtitle }) =>
    $hasSubtitle ? '1rem auto 0' : '0 auto 1.5rem'};
  max-width: ${({ $hasSubtitle }) => ($hasSubtitle ? '100%' : '92%')};
  font-size: 1.375rem;
`;

const Description = styled.p`
  position: relative;
  z-index: 1;
  margin: 0 auto 1.5rem;
  font-size: 1rem;
`;

export { Swirl, Text, Description, Wrapper };
